import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  private _initialized = false;

  public get initialized(): boolean {
    return this._initialized;
  }

  public markInitialized(): void {
    this._initialized = true;
  }
}
